var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "frame-container" },
      [
        _c("div", { staticClass: "info-panel" }, [
          _c("div", { staticClass: "info-panel-container" }, [
            _c("div", { staticClass: "info-panel-item" }, [
              _vm._m(0),
              _c("label", [_vm._v(_vm._s(_vm.studentInfo.studentSieId))])
            ]),
            _c("div", { staticClass: "info-panel-item" }, [
              _vm._m(1),
              _c("label", [
                _vm._v(" " + _vm._s(_vm.studentInfo.studentName) + " ")
              ])
            ]),
            _c("div", { staticClass: "info-panel-item" }, [
              _vm._m(2),
              _c("label", [
                _vm._v(_vm._s(_vm.studentInfo.studentAge) + " años")
              ])
            ]),
            _c("div", { staticClass: "info-panel-item" }, [
              _vm._m(3),
              _c("label", [_vm._v(_vm._s(_vm.studentInfo.impedimentName))])
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "ml-4 mt-4" },
          [
            _vm.studentInfo.isEducativeService
              ? _c("educative-additional-info", {
                  attrs: {
                    "assignment-end-date": _vm.dateFormat(
                      _vm.studentInfo.assignmentEndDate
                    ),
                    "assignment-start-date": _vm.dateFormat(
                      _vm.studentInfo.assignmentStartDate
                    ),
                    value: _vm.studentInfo.educationServiceInfo || {}
                  }
                })
              : _vm._e()
          ],
          1
        ),
        !_vm.studentInfo.isEducativeService
          ? _c(
              "div",
              [
                _vm._l(_vm.referrals, function(srv, index) {
                  return _c(
                    "div",
                    { key: "student-srv" + index, staticClass: "row p-3 mx-3" },
                    [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Tipo de Servicio: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [_vm._v(" " + _vm._s(srv.disciplineName) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Modalidad: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [_vm._v(" " + _vm._s(srv.modality) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Frecuencia: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [_vm._v(" " + _vm._s(srv.frequency) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Duración: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [_vm._v(" " + _vm._s(srv.duration) + " ")]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Vigencia: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(srv.effectiveDateFrom) +
                                " - " +
                                _vm._s(srv.effectiveDateTo) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                }),
                _vm.compensatoryInfo
                  ? _c("div", { staticClass: "row p-3 mx-3" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Número de Solicitud: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.compensatoryInfo.requestNumber) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Tipo de Solicitud: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.compensatoryInfo.requestType) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "legend" }, [
                          _vm._v(" Cantidad Intervenciones: ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "font-weight-normal text-black" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.compensatoryInfo.interventionAmount || "-"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col" }),
                      _c("div", { staticClass: "col" })
                    ])
                  : _vm._e(),
                _vm.referrals.length == 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center"
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "color-secondary-20 mt-3 font-18" },
                          [_vm._v(" Este referido no cuenta con vigencia. ")]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm.referralCount > 1
          ? _c("referral-navigation", {
              attrs: { page: _vm.referralCurrentPage, size: _vm.referralCount },
              on: {
                "on-change-page": function($event) {
                  return _vm.$emit("on-change-page", $event)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-panel-item__section" }, [
      _c("em", { staticClass: "fas fa-address-book" }),
      _c("span", [_vm._v("SIE:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-panel-item__section" }, [
      _c("em", { staticClass: "fas fa-address-book" }),
      _c("span", [_vm._v("Estudiante:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-panel-item__section" }, [
      _c("em", { staticClass: "fas fa-calendar-edit" }),
      _c("span", [_vm._v("Edad:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-panel-item__section" }, [
      _c("em", { staticClass: "fas fa-ballot-check" }),
      _c("span", [_vm._v("Impedimento:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }